var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { TableTasks } from 'app/pages/Project/Tasks/TableTasks';
import getProjectIdFromURL from '../../../core/utils/getProjectIdFromURL';
import { useDispatch, useSelector } from 'react-redux';
import { map, pickBy } from 'lodash';
import { fetchAllTasks, resetTableTasks } from 'app/store/reducers/tasks';
import { userPrefLocalResource } from '../../../core/utils/localUserPrefs.js';
import { tableUserPrefsDataSelector, tableUserPrefsSortBySelector } from 'app/store/selectors/tableUserPrefs';
import { flattenAllTakesByTableFromTasksSelector, tasksByTableSelector } from 'app/store/selectors/tasks';
import useWebsocket from 'app/core/api/useWebSocket';
import { tableFiltersDataSelector, tableFiltersForQueriesSelector } from 'app/store/selectors/tablesFilters';
import { urlToFilters, filtersToQueries } from 'app/components/Table/hooks/useFiltersUtils.js';
import { useLocation } from 'react-router-dom';
import { useProgress } from '../../../hooks/useProgress';
import { getAssetsAttributValues } from 'app/store/selectors/getAssetsAttributValues';
import { getResources } from 'app/store/selectors';
import { getSubResources } from 'app/store/resources/utils/getSubResources';
import { Filters as DefaultFilters } from './Filters.js';
import { getURLParamsKey } from 'app/components/Table/utils.js';
import { resetReduxTableFilters, setAndApplyInputFilters } from 'app/store/reducers/tablesFilters';
import { filtersToURL } from 'app/components/Table/hooks/useFiltersUtils.js';
import allRequests from './tasksRequests';
import routerHistory from 'app/main/routerHistory.js';
import { setActiveTableId } from 'app/store/reducers/tablesPrefs';
import { setStatsOpen } from 'app/store/reducers/stats';
const Tasks = () => {
    var _a, _b, _c, _d;
    useWebsocket();
    const dispatch = useDispatch();
    const { search } = useLocation();
    const { initProgresses, updateProgress, progress } = useProgress();
    const tableId = 'PlannerTaskTable';
    const table = (_a = userPrefLocalResource.getData('tables')) === null || _a === void 0 ? void 0 : _a[tableId];
    const projectId = getProjectIdFromURL();
    const [page, setPage] = useState(0);
    const [requestsLoading, setRequestsLoading] = useState(true);
    const [filtersloading, setFiltersLoading] = useState(true);
    const statsOpen = useSelector((state) => state.statsStatus.statsIsOpen);
    const filtersForQueries = useSelector(tableFiltersForQueriesSelector(tableId));
    const sortBy = useSelector(tableUserPrefsSortBySelector(tableId));
    const tableUserPrefs = useSelector(tableUserPrefsDataSelector(tableId));
    const { count = 0, loading = true, stats = null, statsIsLoading = false, httpProgress = 0, } = (_b = useSelector(tasksByTableSelector(tableId))) !== null && _b !== void 0 ? _b : {};
    const tasksData = useSelector(flattenAllTakesByTableFromTasksSelector(tableId));
    const filtersData = (_c = useSelector(tableFiltersDataSelector(tableId))) !== null && _c !== void 0 ? _c : [];
    const ordering = useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.tablesPrefs.data) === null || _a === void 0 ? void 0 : _a[tableId]) === null || _b === void 0 ? void 0 : _b.sortBy) === null || _c === void 0 ? void 0 : _c.orderingString; });
    const categories = ((_d = getAssetsAttributValues(undefined, 'category')) === null || _d === void 0 ? void 0 : _d.values) || [];
    const projects = getResources(undefined, 'assets', { assetType: 'pj' });
    const episodes = useSelector((state) => pickBy(state.assets.resources, (asset) => asset.assetType === 'ep' && asset.project === getProjectIdFromURL()));
    const progressionStatus = useSelector((state) => state.progressionStatus.resources);
    const assetsAttributes = map(getResources(undefined, 'attributes', projectId ? { project: projectId } : undefined));
    const steps = () => {
        const stepProjects = getResources(undefined, 'stepProjects', projectId ? { project: projectId } : undefined, [
            'stepInst',
        ]);
        if (projectId)
            return getSubResources(stepProjects, 'stepInst');
        return getResources(undefined, 'steps');
    };
    const filters = useMemo(() => {
        if (!requestsLoading) {
            const filt = new DefaultFilters({
                episodes,
                categories,
                progressionStatus,
                assetsAttributes,
                projects,
            }).getFilters();
            return filt;
        }
    }, [requestsLoading]);
    useEffect(() => {
        dispatch(setActiveTableId(tableId));
        (() => __awaiter(void 0, void 0, void 0, function* () {
            initProgresses();
            yield allRequests({ projectId });
            setRequestsLoading(false);
        }))();
        return () => {
            dispatch(setActiveTableId(''));
            dispatch(setStatsOpen(false));
            dispatch(resetReduxTableFilters(tableId));
            dispatch(resetTableTasks(tableId));
        };
    }, []);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (search && (filters === null || filters === void 0 ? void 0 : filters.length) && filtersloading) {
                const params = new URLSearchParams(search);
                const urlCurrentFilters = params.get(getURLParamsKey('filters', tableId));
                if (urlCurrentFilters) {
                    const urlFilters = yield urlToFilters(urlCurrentFilters, filters, undefined, undefined, false);
                    dispatch(setAndApplyInputFilters({ tableId, value: urlFilters }));
                }
                setFiltersLoading(false);
            }
            if (!search && (filters === null || filters === void 0 ? void 0 : filters.length) && (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length)) {
                dispatch(resetReduxTableFilters(tableId));
                setFiltersLoading(false);
            }
            else if (!search && (filters === null || filters === void 0 ? void 0 : filters.length)) {
                setFiltersLoading(false);
            }
        }))();
    }, [filters]);
    useEffect(() => {
        const url = filtersToURL(filtersData);
        routerHistory.updateQuery({ [getURLParamsKey('filters', tableId)]: url || null });
    }, [filtersData]);
    useEffect(() => {
        if (!requestsLoading && !filtersloading) {
            const { queries: filtQueries } = filtersToQueries(filtersForQueries !== null && filtersForQueries !== void 0 ? filtersForQueries : []);
            const queries = Object.assign({ page_size: (tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize) || (table === null || table === void 0 ? void 0 : table.pageSize) || 50, page: page + 1, ordering }, filtQueries);
            dispatch(fetchAllTasks({ tableId, queries }));
            initProgresses();
        }
    }, [tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize, page, ordering, sortBy, requestsLoading, filtersloading, filtersForQueries]);
    const getProgressAverage = (progresses) => {
        const values = Object.values(progresses);
        const progressAverage = values.reduce((acc, val) => acc + val) / values.length;
        return progressAverage;
    };
    return (_jsx("div", { className: "fullWidth fullHeight", children: _jsx(TableTasks, { tableId: tableId, enableStats: true, projectId: projectId, data: tasksData, loading: loading, count: count, statsOpen: statsOpen, setStatsOpen: () => dispatch(setStatsOpen(!statsOpen)), stats: stats, statsIsLoading: statsIsLoading, requestsLoading: requestsLoading, assetsAttributes: assetsAttributes, progressionStatus: progressionStatus, steps: steps, projects: projects, filters: filters, progress: getProgressAverage(Object.assign(Object.assign({}, progress), { tasks: httpProgress })), page: page, setPage: setPage }) }));
};
export default Tasks;
